import React from 'react'
import { Button, Card } from 'react-bootstrap'

/** template card displayed by react-joyride for the help tour */
const TourCard = ({
  index,
  step,
  isLastStep,
  backProps,
  primaryProps,
  closeProps,
  tooltipProps,
  imgSrcTour
}) => (
  <Card
    className='border-0'
    style={{ width: '30rem', maxWidth: '100%', borderRadius: '15px' }}
    {...tooltipProps}
  >
    {imgSrcTour && step.placement === 'center' && (
      <Card.Img variant='top' src={imgSrcTour} alt='' />
    )}
    <Card.Body>
      {step.title && <Card.Title>{step.title}</Card.Title>}
      {step.placement !== 'center' && <hr />}
      <Card.Text className='mb-3'>{step.content}</Card.Text>
      <div className='d-flex justify-content-end'>
        <Button variant='outline-dark' disabled={index === 0} {...backProps}>
          Previous
        </Button>
        <Button
          className='ml-2'
          variant={isLastStep ? 'outline-dark' : 'secondary'}
          disabled={isLastStep}
          {...primaryProps}
        >
          Next
        </Button>
        <Button
          className='ml-4'
          variant={isLastStep ? 'secondary' : 'outline-dark'}
          {...closeProps}
        >
          End Tour
        </Button>
      </div>
    </Card.Body>
  </Card>
)

export { TourCard }
